import { Extension } from '@tiptap/core';
import type { Node as PMNode } from '@tiptap/pm/model';
import { TextSelection } from '@tiptap/pm/state';

const SCOPED_CONTENT = new Set([
  'tableCell',
  'tableHeader',
  'contentPageSection',
  'planVanAanpakSection',
]);

/** The nearest editable container owns Select All, including repeated presses. */
export function activeContentRange(doc: PMNode, anchor: number) {
  const $anchor = doc.resolve(anchor);
  for (let depth = $anchor.depth; depth > 0; depth--) {
    if (SCOPED_CONTENT.has($anchor.node(depth).type.name)) {
      return { from: $anchor.start(depth), to: $anchor.end(depth) };
    }
  }
  return null;
}

export const ScopedSelectAll = Extension.create({
  name: 'scopedSelectAll',
  priority: 1000,
  addKeyboardShortcuts() {
    return {
      'Mod-a': () => {
        if (!this.editor.isEditable) return false;
        const { state, view } = this.editor;
        const range = activeContentRange(state.doc, state.selection.anchor);
        if (!range) return false;
        const selection = TextSelection.between(
          state.doc.resolve(range.from),
          state.doc.resolve(range.to)
        );
        // An image-only container must not find text on an adjacent page.
        if (selection.from >= range.from && selection.to <= range.to) {
          view.dispatch(state.tr.setSelection(selection));
        }
        return true;
      },
    };
  },
});
